import { useEffect, useState } from 'react';

// Keep in sync with FloatingNavigation.css and the full desktop menu's 1440px breakpoint.
// Phones and tablets share the bottom-right menu in portrait and landscape.
export const PHONE_NAVIGATION_QUERY = '(max-width: 1439px)';
export function usePhoneNavigation() {
  const [phone, setPhone] = useState(() => Boolean(window.matchMedia?.(PHONE_NAVIGATION_QUERY).matches));
  useEffect(() => {
    const media = window.matchMedia?.(PHONE_NAVIGATION_QUERY);
    if (!media) return undefined;
    const update = () => setPhone(media.matches);
    update(); media.addEventListener?.('change', update);
    return () => media.removeEventListener?.('change', update);
  }, []);
  return phone;
}
